import { ReactNode } from "react";
import styles from "./AnalyticsHeader.module.scss";
import Badge from "../../xepp/badge/Badge";

type Props = {
	title: string;
	subtitle?: string;
	/**
	 * The figures under this heading are stand-ins, not measurements. Beside the title
	 * rather than in the subtitle: someone about to screenshot a number has to trip
	 * over this, and a widget with no subtitle would otherwise have nowhere to say it.
	 */
	mock?: boolean;
	/** Sits to the right of the title, e.g. a chart's legend. */
	children?: ReactNode;
};

/** The heading every analytics widget carries, so they all wear the same one. */
const AnalyticsHeader = ({ title, subtitle, mock = false, children }: Readonly<Props>) => (
	<div className={styles.header}>
		<div>
			<div className={styles.titleRow}>
				<h2 className={styles.title}>{title}</h2>
				{mock && <Badge variant="inactive">Mock data</Badge>}
			</div>
			{subtitle && <p className={styles.subtitle}>{subtitle}</p>}
		</div>
		{children}
	</div>
);

export default AnalyticsHeader;
